import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_SERVICE,
    withCredentials: true,
    // Ensure this is set properly
    headers: {
        'Content-Type': 'application/json'
    } // Required for session-based authentication
});

// Attach interceptors (if needed)
axiosInstance.interceptors.request.use(config => {
    //const token = localStorage.getItem('jwt_token'); // Get the JWT token from localStorage
    const token = sessionStorage.getItem('jwt_token');
    console.log("before the request call ",token);
    if (token) {
        // If token exists, attach it to the Authorization header of the request
        config.headers['Authorization'] = `Bearer ${token}`;
    }else{
        console.log("unable to retrieve token from session");
    }
    return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
export default axiosInstance